var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdharV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,21.5c-0.7-0.1-1.3-0.3-2-0.7c-0.5-0.3-0.9-0.6-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.1c-2.5,0-5,0-7.5,0 c-0.5,0-0.7-0.2-0.7-0.7c0-5.2,0-10.5,0-15.7c0-0.5,0.2-0.7,0.7-0.7c4.3,0,8.5,0,12.8,0c0.5,0,0.7,0.2,0.7,0.7c0,3.7,0,7.5,0,11.2 c0,0.2,0,0.3,0.2,0.3c1.4,0.6,2.4,1.6,3.2,2.8c0.2,0.2,0.2,0.5,0,0.7c-0.9,1.4-2.1,2.5-3.7,3c-0.3,0.1-0.6,0.2-1,0.2 C15.7,21.5,15.4,21.5,15,21.5z M10.4,18.5C10.4,18.4,10.4,18.4,10.4,18.5c-0.3-0.5-0.3-0.7,0-1.1c0.4-0.6,0.9-1.2,1.5-1.6 c1.2-1,2.4-1.5,4-1.4c0.2,0,0.2,0,0.2-0.2c0-3.4,0-6.8,0-10.2c0-0.2,0-0.2-0.2-0.2c-3.8,0-7.6,0-11.3,0C4.4,3.7,4.3,3.8,4.3,4 c0,4.8,0,9.5,0,14.3c0,0.2,0,0.2,0.2,0.2c1.9,0,3.8,0,5.7,0C10.3,18.5,10.4,18.5,10.4,18.5z M15.5,15.6c-0.4,0-0.8,0.1-1.1,0.2 c-1.1,0.4-2,1.1-2.7,2c-0.1,0.1,0,0.2,0,0.3c0.4,0.5,0.8,0.9,1.3,1.3c1.2,0.9,2.5,1.2,3.9,0.7c1.1-0.4,1.9-1.1,2.7-2 c0.1-0.1,0-0.2,0-0.2c-0.3-0.4-0.6-0.7-1-1.1C17.6,16,16.7,15.6,15.5,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,7.3c1,0,2,0,3,0c0.3,0,0.5,0.2,0.6,0.4c0.1,0.3,0,0.5-0.3,0.7c-0.1,0.1-0.2,0.1-0.3,0.1 c-2,0-3.9,0-5.9,0c-0.4,0-0.6-0.3-0.6-0.6c0-0.3,0.2-0.6,0.6-0.6C8.2,7.3,9.2,7.3,10.2,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,10.8c-1,0-2,0-2.9,0c-0.5,0-0.8-0.5-0.5-0.9c0-0.2,0.2-0.3,0.5-0.3c1.5,0,3.1,0,4.6,0c0.4,0,0.8,0,1.2,0 s0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6C12.1,10.8,11.2,10.8,10.2,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,12c0.5,0,1,0,1.4,0s0.6,0.3,0.6,0.6c0,0.4-0.3,0.6-0.6,0.6c-1,0-1.9,0-2.9,0c-0.4,0-0.6-0.2-0.6-0.6 c0-0.4,0.3-0.6,0.6-0.6C7.8,12,8.3,12,8.7,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,17.9c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8S17.3,16.9,17.3,17.9z M16.1,17.9 c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6C15.9,18.5,16.1,18.2,16.1,17.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.7,
    y: -1.1,
    transform: "matrix(0.7026 -0.7116 0.7116 0.7026 -4.9702 12.1081)",
    className: "st0",
    width: 0.6,
    height: 26.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdharV);
export default __webpack_public_path__ + "static/media/adhar_v.6907dba11ab604e64b823c46f1a497e1.svg";
export { ForwardRef as ReactComponent };